import PlainItemsSelector from 'app/common/ui-next/plain-selector/plain-items-selector'
import { sortByTitle } from 'app/common/lib/sort'

import type { SurveyFilterItemProps } from './types'


export const CityFilter = ({
  value,
  creation,
  options,
  loading,
  multiple,
  colorInverse,
  disabled,
  onChange,
}: SurveyFilterItemProps) => {
  const handleChange = (cityIds: Array<string>) => {
    onChange({
      ...value,
      cityIds,
      districtIds: [],
      schoolIds: [],
    })
  }

  return (
    <PlainItemsSelector
      id="surveyCity"
      label="Населенный пункт"
      header="Выбор населенного пункта"
      sortFunc={sortByTitle}
      selection={value.cityIds}
      items={options.cities}
      multiple={multiple}
      colorInverse={colorInverse}
      loading={loading}
      disabled={loading || disabled}
      onChange={handleChange}
      selectedAllOnEmptySelection={!creation}
      alwaysAutoSelect={creation}
      hideButtonReset={creation && options.cities.length === 1}
      skipUpperSpace
      disableAutoSelect={!creation}
      doOnBadgeCrossClick="clear"
      maxViewCountBadge={3}
    />
  )
}
